import { defaultDistritoJudicial, DistritoJudicialProps } from "./DistritoJudicialInterface";
import { defaultMateria, MateriaProps } from "./MateriaInterface";

// Definición de defaults

export const defaultAutoridadExhortoLibrado: AutoridadExhortoLibradoProps = {
    idAutoridadExhortoLibrado: 0,
    descripcion:               '',
    activo:                    false,
    idDistritoJudicial:        0,
    distritoJudicial:          defaultDistritoJudicial,
    idMateria:                 0,
    materia:                   defaultMateria,
}

// Creación de interfaces

export interface AutoridadExhortoLibradoProps {
    idAutoridadExhortoLibrado:         number;
    descripcion:                        string;
    activo:                             boolean;
    idDistritoJudicial?:                number;
    distritoJudicial?:                  DistritoJudicialProps;
    idMateria?:                         number;
    materia?:                           MateriaProps;

}